// removed by extract-text-webpack-plugin
module.exports = {"container":"Gde37ed","content":"G4a6327 G1c13d6 G2f6568 Gd71c60","bottom":"G882400"};